import { Image } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useSelectorIsOneRosterActivatedSchool } from '../../../app';
import MathleticsIcon from '../../../components/icons/logo_mathletics.svg';
import threeEssentialsIcon from '../../../components/product-switcher/icons/three_essentials.svg';
import { ProductSwitcher } from '../../../components/product-switcher/product-switcher';
import { useSelectorPromoVideoValidTeacherYearGroups } from '../../../configuration';
import {
    useSelectorIsInternalUsers,
    useSelectorUserProfiles
} from '../../../user-profiles';
import { useSelectorIsAppDataReady } from '../../state';
import { fetchNotifications } from '../notifications';
import { UserProfile } from '../user-profile';
import { NeedHelpButton } from './components/need-help-buttton/need-help-button';
import { SchoolInfo } from './components/school-info/school-info';
import {
    HeaderBackground,
    HeaderMain,
    ProductWrapper,
    LinksContainer,
    LinksWrapper,
    Divider,
    SchoolName
} from './header.styled';
import { useIsValidCountry } from './hooks/use-is-valid-country';
import { useShowPromoVideoModal } from './hooks/use-show-promo-video-modal';

export const Header = () => {
    const isOneRosterActivatedSchool = useSelectorIsOneRosterActivatedSchool();
    const isAppDataReady = useSelectorIsAppDataReady();
    const isInternalUser = useSelectorIsInternalUsers();
    const dispatch = useDispatch();
    const { data: userProfilesData } = useSelectorUserProfiles();
    const validYearGroups = useSelectorPromoVideoValidTeacherYearGroups();
    const classroomsYearGroups = userProfilesData?.productInfos?.[0]?.classroomsYearGroups;
    const isValidCountryCode = useIsValidCountry({ countryCode: userProfilesData?.country?.code });

    useShowPromoVideoModal({
        classroomsYearGroups,
        validYearGroups,
        isValidCountryCode
    });

    useEffect(() => {
        if (!isAppDataReady) return;

        dispatch(fetchNotifications());
    }, [dispatch, isAppDataReady]);

    // Dont show the menu and product icon before we know
    // what it we need to render, eg what the current product is and so on.
    if (!isAppDataReady) {
        return null;
    }

    return (
        <HeaderBackground>
            <ProductSwitcher />
            <HeaderMain>
                <ProductWrapper>
                    {isOneRosterActivatedSchool && <Image src={threeEssentialsIcon} h={'40px'} />}
                    <SchoolName style={{ justifyContent: isOneRosterActivatedSchool ? 'center' : 'start' }}>
                        {!isInternalUser && <Image src={MathleticsIcon} w={'100px'} h={'36px'} fit={'cover'} />}
                        <SchoolInfo />
                    </SchoolName>
                </ProductWrapper>
                <LinksContainer>
                    <LinksWrapper divider={<Divider />}>
                        {!isInternalUser && <NeedHelpButton />}
                        <UserProfile
                            classroomsYearGroups={classroomsYearGroups}
                            validYearGroups={validYearGroups}
                            isValidCountryCode={isValidCountryCode}
                        />
                    </LinksWrapper>
                </LinksContainer>
            </HeaderMain>
        </HeaderBackground>
    );
};
